import { Action, createReducer, on } from '@ngrx/store';

import { DepartmentActions } from './department.actions';
import { DepartmentState } from './department.state';

export const initDepartmentState: DepartmentState = {
  departments: null,
  error: null,
  installationId: null,
  departmentName: null,
};

export const departmentReducer = createReducer<DepartmentState, Action>(
  initDepartmentState,
  on(
    DepartmentActions.getAllDepartments,
    (_state): DepartmentState => ({ ...initDepartmentState })
  ),
  on(
    DepartmentActions.getAllDepartmentsSuccess,
    (state, { departments }): DepartmentState => ({
      ...state,
      departments,
    })
  ),
  on(
    DepartmentActions.getAllDepartmentsError,
    (state, { error }): DepartmentState => ({ ...state, error })
  ),
  on(
    DepartmentActions.updateDepartment,
    (_state, { installationId, departmentName }): DepartmentState => ({
      ...initDepartmentState,
      installationId,
      departmentName,
    })
  ),
  on(
    DepartmentActions.updateDepartmentSuccess,
    (state): DepartmentState => ({
      ...state,
    })
  ),
  on(
    DepartmentActions.updateDepartmentError,
    (state, { error }): DepartmentState => ({
      ...state,
      error,
    })
  ),
  on(
    DepartmentActions.deleteDepartment,
    (_state, { installationId }): DepartmentState => ({
      ...initDepartmentState,
      installationId,
    })
  ),
  on(
    DepartmentActions.deleteDepartmentSuccess,
    (state): DepartmentState => ({
      ...state,
    })
  ),
  on(
    DepartmentActions.deleteDepartmentError,
    (state, { error }): DepartmentState => ({
      ...state,
      error,
    })
  )
);
